import { render, staticRenderFns } from "./BulletBlock.vue?vue&type=template&id=56311435&"
import script from "./BulletBlock.vue?vue&type=script&lang=js&"
export * from "./BulletBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports